const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
        metrics: {
          filterDate: "Filter by day",
          sales: {
            title: "Sales",
            subtitle: "{{count}} purchase(s) sent to pixel",
          },
          clicks: {
            title: "Link clicks",
            subtitle: "Counter accesses on selected day",
          },
          conversations: {
            title: "Conversations started",
            subtitle: "Contacts matched in Whaticket on selected day",
          },
        },
        messages: {
          inAttendance: {
            title: "In Service"
          },
          waiting: {
            title: "Waiting"
          },
          closed: {
            title: "Closed"
          }
        }
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
          counterPhone: "Counter number",
          autoDisableCounter: "Auto deactivation",
        },
        autoDisable: {
          active: "Active",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
          counterPhone: "Counter number",
          autoDisableCounter: "Automatic deactivation",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          whatsapp: "Default Connection",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
        },
        buttons: {
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to queue",
        fieldConnectionLabel: "Transfer to connection",
        fieldQueuePlaceholder: "Please select a queue",
        fieldConnectionPlaceholder: "Please select a connection",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        connectionTitle: "Connection that is currently being used.",
        buttons: {
          accept: "Accept",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          tickets: "Tickets",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          pixel: "Pixel",
          counterNumbers: "Numbers",
          leadMessages: "Message Log",
          queues: "Queues",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
          proxy: "Proxy",
        },
        appBar: {
          autoAttend: "Auto attend with AI",
          translation: "Real-time translation (turn off to save API usage)",
          translationNeedsKey:
            "Set Google Translation API key in Settings to enable",
          translationEnabled: "Auto translation",
          agentLanguage: "Main language (panel)",
          outputLanguage: "Output language (sent messages)",
          translationPrivacyNote:
            "Google Cloud Translation API. Enable the API in Google Cloud Console.",
          translationApiKey: "Google Translation API key",
          translationApiKeyHelp:
            "Optional if Gemini key is already set in AI settings. Saves without Cloud Translation validation.",
          translationSaveApiKey: "Save key",
          translationKeySaved: "Key saved successfully",
          translationKeyConfigured: "Cloud Translation key configured",
          translationUsesGemini: "Using Gemini key from AI settings",
          translationKeyMissing: "No Cloud key — uses AI Gemini if available",
          translationApiKeyEmpty: "Paste the key before saving",
          translationApiKeyReplace: "Paste a new key to replace",
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      queues: {
        title: "Queues",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          whatsapp: "Default Connection",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          aiAssistant: {
            title: "AI Assistant",
            privacyNote:
              "Conversations are sent to the configured AI provider (Gemini or Anthropic). Configure the keys below.",
            provider: "Active provider",
            geminiSection: "Google Gemini",
            anthropicSection: "Anthropic (Claude Sonnet)",
            model: "Gemini model",
            anthropicModel: "Claude model",
            apiKey: "Gemini API Key",
            anthropicApiKey: "Anthropic API Key",
            saveApiKey: "Save Gemini key",
            saveAnthropicApiKey: "Save Anthropic key",
            postSalePromptTitle: "Post-sale prompt (AI button in chat)",
            prompt: "Post-sale prompt",
            promptHelp:
              "Placeholders: {nome}, {telefone}, {valor_venda}, {utm_campaign}",
            savePrompt: "Save post-sale prompt",
            atendimentoPromptTitle: "Attendance prompt (auto-accept conversations)",
            atendimentoPromptHelp:
              "Used when auto-attend is enabled in the header. Separate from post-sale.",
            atendimentoPrompt: "Attendance prompt",
            saveAtendimentoPrompt: "Save attendance prompt",
            autoAttendNewContactsOnly: "AI auto-attend for new contacts only",
            autoAttendNewContactsOnlyHelp:
              "When enabled, automatic AI attendance only starts for contacts who have never received a human reply. Returning contacts wait for human agents.",
            autoAttendNewContactsOnlyOptions: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
            maxReplies: "Max replies per hour (per ticket)",
            historyMessages: "History messages in context (recommended: 40+)",
            replyDelayMin: "Minimum delay (seconds)",
            replyDelayMax: "Maximum delay (seconds)",
            replyDelayHelp:
              "AI waits a random time between min and max before replying. If max is 0 or equals min, uses fixed min delay.",
          },
          translation: {
            title: "Real-time translation",
            privacyNote:
              "Uses Google Cloud Translation API. Enable the API in Google Cloud Console (separate from Gemini).",
            enabled: "Translation enabled",
            agentLanguage: "Agent language (read/write in panel)",
            apiKey: "Google Translation API key",
            apiKeyHelp:
              "You can use the same Google account as Gemini, but Cloud Translation API must be enabled.",
            saveApiKey: "Save translation key",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
      },
      messagesList: {
        aiBadge: "AI",
        translationLabel: "Translation",
        sentTranslationLabel: "Sent",
        translateButton: "Translate",
        translating: "Translating...",
        header: {
          assignedTo: "Assigned to:",
          aiActive: "AI active",
          aiModeSdr: "SDR",
          aiModePostSale: "Post-sale",
          aiDisable: "Turn off AI",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            pixel: "Pixel",
            ai: "AI",
            aiOn: "AI on",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        translationPreview: "Will be sent in {{language}}: {{text}}",
        translationAgentPreview: "Translation to {{language}}: {{text}}",
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        customerLanguage: "Customer language",
        customerLanguageAuto: "Detect automatically",
        pixelCreative: "Creative (Pixel)",
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_TRANSLATION_FAILED:
          "Could not translate the message. Check the key and Cloud Translation API in Google Cloud.",
        ERR_TRANSLATION_API_BLOCKED:
          "Cloud Translation API is blocked. Enable it at console.cloud.google.com/apis/library/translate.googleapis.com and check key restrictions.",
        ERR_TRANSLATION_INVALID_KEY:
          "Invalid Google Translation key. Generate a new key in Google Cloud Console.",
        ERR_TRANSLATION_KEY_TEST_FAILED:
          "Could not validate the Google Translation key. Try again.",
        ERR_TRANSLATION_API_KEY_EMPTY: "Enter the Google Translation key.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
        ERR_PIXEL_INVALID_VALUE: "Enter a valid sale value.",
        ERR_PIXEL_LEAD_NOT_FOUND: "Pixel lead not found for this contact.",
        ERR_PIXEL_ALREADY_CONVERTED: "This conversion was already sent to the pixel.",
        ERR_PIXEL_PHONE_NOT_FOUND: "Contact phone not found.",
        ERR_PIXEL_SEND_FAILED: "Failed to send conversion to the pixel.",
        ERR_COUNTER_NUMBERS_LIST: "Failed to list counter numbers.",
        ERR_COUNTER_NUMBER_ADD: "Failed to add number.",
        ERR_COUNTER_NUMBER_TOGGLE: "Failed to toggle number status.",
        ERR_COUNTER_NUMBER_UPDATE: "Failed to update number.",
        ERR_COUNTER_NUMBER_DELETE: "Failed to delete number.",
        ERR_LEAD_MESSAGES_LIST: "Failed to load recent messages.",
      },
      leadMessages: {
        title: "Message Log",
        section: {
          title: "Latest Received Messages",
          subtitle:
            "Recent leads — message, destination WPP number, campaign and status",
        },
        stats: {
          total: "Total leads",
          today: "Leads today",
          converted: "Converted",
        },
        table: {
          date: "Date/Time",
          message: "Message",
          destination: "Destination WPP",
          campaign: "Campaign",
          status: "Status",
        },
        status: {
          pending: "Pending",
          converted: "Sold · €{{value}}",
        },
        empty: "No messages received yet.",
      },
      proxy: {
        title: "WhatsApp Proxy",
        formatHint:
          "Paste as host:port:username:password — default type HTTP (optional: socks5 or socks4 at the end)",
        status: {
          enabled: "Proxy enabled",
          disabled: "Proxy disabled",
        },
        source: {
          settings: "Source: panel",
          env: "Source: .env",
          none: "No proxy configured",
        },
        fields: {
          enabled: "Use proxy for WhatsApp",
          rawLine: "Full proxy string",
          parsedTitle: "Automatically recognized fields",
          host: "Host",
          port: "Port",
          username: "Username",
          password: "Password",
          passwordKeep: "Leave blank to keep current password",
          type: "Type",
        },
        buttons: {
          save: "Save proxy",
          check: "Test proxy",
          reload: "Reload",
        },
        check: {
          ok: "Proxy is working",
          fail: "Proxy test failed",
          latency: "Latency: {{ms}} ms",
          ip: "External IP: {{ip}}",
        },
        toasts: {
          saved: "Proxy saved successfully!",
          checkOk: "Proxy tested successfully!",
          checkFail: "Proxy did not respond",
        },
        note:
          "After changing the proxy, disconnect and reconnect the WhatsApp session in Connections to apply the change.",
      },
      counterNumbers: {
        title: "Counter Numbers",
        stats: {
          daily: "Daily clicks",
          total: "Total clicks",
          active: "Active channels",
        },
        form: {
          addTitle: "Add new channel",
          name: "Name",
          namePlaceholder: "e.g. Main WPP",
          phone: "Phone",
          message: "Default message (optional)",
          add: "Add",
          save: "Save",
          cancel: "Cancel",
          phoneRequired: "Phone is required.",
        },
        table: {
          active: "Active",
          name: "Channel",
          daily: "Clicks (day)",
          total: "Clicks (total)",
          rotation: "Rotation",
          actions: "Actions",
        },
        rotation: {
          next: "Next",
          last: "Last",
          queued: "Queued",
          inactive: "Inactive",
        },
        edit: {
          title: "Edit channel",
        },
        confirmDelete: {
          title: "Remove number",
          message: "Are you sure? The number will be removed from the click counter.",
        },
        toasts: {
          added: "Number added successfully!",
          updated: "Number updated!",
          deleted: "Number removed!",
        },
      },
      pixel: {
        title: "Pixel",
        creative: "Creative",
        adLabel: "Ad",
        adId: "Ad ID",
        adNotFound: "Ad not identified",
        campaignLabel: "Campaign",
        campaignNotFound: "Campaign not identified",
        search: "Search by message, phone or creative",
        loadMore: "Load more",
        stats: {
          total: "Checked",
          complete: "Complete",
          incomplete: "Incomplete",
          converted: "Converted",
        },
        table: {
          contact: "Contact",
          message: "Message",
          creative: "Creative",
          phone: "Phone",
          status: "Pixel Status",
          checkedAt: "Checked at",
        },
        status: {
          complete: "Complete",
          incomplete: "Incomplete",
          notFound: "Not found",
          convertedShort: "Converted",
          converted: "Converted · €{{value}}",
          purchasesSummary: "{{count}} purchase(s) · Total €{{value}}",
        },
        modal: {
          title: "Send conversion to Pixel",
          phone: "Phone (automatic)",
          value: "Sale value (€)",
          send: "Send to Pixel",
          sendUpsell: "Send upsell",
          cancel: "Cancel",
          refresh: "Check again",
          message: "Tracked message",
          lookupDate: "Click date",
          leadDate: "Click date",
          lastPurchase: "Last purchase sent",
          invalidValue: "Enter a valid value.",
          success: "Conversion sent to pixel successfully!",
          upsellSuccess: "Upsell sent to pixel successfully!",
          refreshed: "Pixel data updated.",
        },
        manual: {
          title: "Manual search",
          date: "Click date",
          message: "Exact message",
          messagePlaceholder: "Paste the message the customer sent on WhatsApp",
          search: "Search lead",
          phone: "Buyer phone",
          notFound: "No lead found for this message and date.",
          clear: "Clear",
          messageRequired: "Enter the message to search.",
          dateRequired: "Enter the click date.",
          phoneRequired: "Enter the buyer phone.",
        },
      },
    },
  },
};

export { messages };
